var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 47",
    d: "M13.8361 22.3481C15.1294 22.12 16.365 21.6395 17.4726 20.9339C18.5802 20.2283 19.5379 19.3115 20.2911 18.2358C21.0444 17.16 21.5783 15.9465 21.8626 14.6644C22.1468 13.3823 22.1757 12.0568 21.9477 10.7635C21.7196 9.47025 21.2391 8.23456 20.5335 7.127C19.8279 6.01945 18.9111 5.06171 17.8354 4.30848C16.7596 3.55525 15.5461 3.02127 14.264 2.73704C12.9819 2.45281 11.6564 2.42388 10.3631 2.65192C9.06986 2.87996 7.83417 3.36049 6.72661 4.06609C5.61905 4.77168 4.66132 5.68851 3.90809 6.76424C3.15486 7.83996 2.62088 9.05352 2.33665 10.3356C2.05242 11.6177 2.02349 12.9432 2.25153 14.2365C2.47957 15.5298 2.9601 16.7654 3.6657 17.873C4.37129 18.9806 5.28812 19.9383 6.36385 20.6915C7.43957 21.4448 8.65313 21.9787 9.93522 22.263C11.2173 22.5472 12.5428 22.5761 13.8361 22.3481L13.8361 22.3481Z",
    stroke: "#9D6363",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 133",
    d: "M12.0996 12.5L12.0996 18.5",
    stroke: "#9D6363",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 134",
    d: "M12.0996 7.5L12.0996 6.5",
    stroke: "#9D6363",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Info.95fd96a4a061ea0af77901610b77b566.svg";